module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-info-wrap",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.orders.set) ? _c('div', {
    staticClass: "col-sm-12 card",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('h1', {
    staticClass: "card-title"
  }, [_vm._v("Your Orders")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Ordered From")]), _vm._v(" "), _c('th', [_vm._v("Order Total")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#df4d4d"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v("\r\n                        " + _vm._s(order.order_date) + "\r\n                        "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "p-tiny"
    }, [_vm._v("Tap to view")])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_business))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total))]), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])]) : _c('p', [_vm._v("No orders yet")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "ordersModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Order No " + _vm._s(_vm.order.order_no))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.product_name) + " - " + _vm._s(item.order_delivery_city))])])
  })], 2), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Payment Mode: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Status: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Delivery Fee Details:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_not_set))])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Delivery Location:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_city))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Address:  ")]), _vm._v(_vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Order Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88e78458"}!./src/pages/Buypoint/Orders/template.html
// module id = 268
// module chunks = 0